export default __webpack_public_path__ + "static/media/Jerkin of the Savage Fang.22306bbd.jpg";